var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromigerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1106 199",
    style: {
      enableBackground: "new 0 0 1106 199"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    className: "st0",
    d: "M40.4,28.4h47.1c31.4,0,54.7,11,54.7,44.2c0,32.1-23.7,46.5-54.7,46.5H65.9v52.7H40.4V28.4z  M85.5,98.8c21.3,0,31.5-8.6,31.5-26.1c0-17.7-10.7-23.8-31.5-23.8H65.9v49.9H85.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.2,112.1c17.2-6,28.7-19.4,28.7-41.1c0-32.1-23.1-42.6-52.9-42.6h-47.9v143.4h25.6v-56H218l30.9,56h28.6 L243.2,112.1z M196.8,48.8h19.7c19.6,0,30.3,5.8,30.3,22.2c0,16.2-10.7,24.4-30.3,24.4h-19.7V48.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st0",
    d: "M293.7,99.4c0-47.1,23.1-73.7,56.4-73.7s56.4,26.5,56.4,73.7c0,48-23.1,75-56.4,75 S293.7,147.5,293.7,99.4z M380.3,99.4c0-32.9-11.9-51.5-30.2-51.5C331.9,48,320,66.5,320,99.4c0,33.8,11.9,52.8,30.2,52.8 C368.4,152.2,380.3,133.2,380.3,99.4L380.3,99.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "st0",
    d: "M430.1,28.4h28.2l17,55.9l5.9,21.5h0.9l5.8-21.5l17.2-55.9h28.2v143.4h-22.5V114 c0-15.1,2.5-44.9,3.7-58.8h-0.7l-9.6,33.3l-15.8,45.3h-14.4l-15.7-45.3l-9.3-33.3h-0.6c1.5,13.9,3.7,43.7,3.7,58.8v57.9h-22.1 L430.1,28.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    className: "st0",
    d: "M566.1,150.4h34.5V49.8h-34.5V28.4h94.6v21.4h-34.5v100.5h34.5v21.5h-94.6V150.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st0",
    d: "M689.8,100.5c0-47.1,27.8-74.8,65-74.8c15.5-0.1,30.3,6.4,40.7,17.9l-14.2,15.9 c-6.7-7.6-16.4-11.8-26.5-11.6c-22.8,0-38.6,19.7-38.6,51.8c0,32.7,13.8,52.5,39,52.5c7,0.3,13.8-1.9,19.2-6.2v-31h-24.6V94.2h47.7 v63.3c-12,11-27.6,17.1-43.9,17C717.4,174.4,689.8,148.1,689.8,100.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st0",
    d: "M833.4,28.4h92v21.4h-66.4v36.7h56.3V108h-56.3v42.4h68.6v21.5h-94.1V28.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1033,112.1c17.2-6,28.7-19.3,28.7-41.1c0-32.1-23.1-42.6-52.9-42.6h-47.9v143.4h25.6v-56h21.2l30.8,56h28.6 L1033,112.1z M986.5,48.8h19.7c19.6,0,30.3,5.8,30.3,22.2c0,16.2-10.7,24.4-30.3,24.4h-19.7V48.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromigerIcon);
export default __webpack_public_path__ + "static/media/promiger-icon.193c86de3c56faa99909a9831255ab9f.svg";
export { ForwardRef as ReactComponent };